import React, { FC } from 'react'
import AppRouter from '../app-router/index'

const RouterProvider:FC = () => {
  return <AppRouter />
}

export default RouterProvider